import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=7c8dbf1b"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SideBar.vue?vue&type=style&index=0&id=7c8dbf1b&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports